import * as React from 'react';
import { useLocation } from 'react-router-dom';
import NavigationWrapper from 'Views/Components/Navigation/NavigationWrapper';
import SecuredPage from 'Views/Components/Security/SecuredPage';
import UpdatePassword from 'Views/Components/_HumanWritten/UpdatePassword/UpdatePassword';

export interface UpdatePasswordLocationState {
	email: string;
	name: string;
	role: string;
}

function UpdatePasswordPage() {
	const location = useLocation();

	return (
		<>
			<NavigationWrapper />
			{/* .body-content is the app shell's scrollable grid area — the account pages sit in it too. */}
			<div className="body-content">
				{!location.state && <UpdatePassword />}
				{location.state && (
					<SecuredPage groups={['Super Administrators', 'Admin', 'Manager', 'Staff']}>
						<UpdatePassword userInfo={location.state as UpdatePasswordLocationState | undefined} />
					</SecuredPage>
				)}
			</div>
		</>
	);
}

export default UpdatePasswordPage;
